import Axios from 'axios';

export default {
    get(cep) {
        let URL = 'https://viacep.com.br/ws/'+cep+'/json';
        return Axios.get(URL);
    },
};